import { observer } from 'mobx-react-lite';
import { useSearchParams } from 'react-router-dom';
import { authorizationStore } from '../authorization.store';
import { globalStore } from '../../../global.store';
import { dashboardStore } from '../../../layout/dashboard/dashboard.store';
import { AuthMainBlock } from '../../../components/authMainBlock';
import { ImgImporter } from '../../../ui/imgImporter';
import './authorization.scss';
import { useEffect } from 'react';
import { sendMessageStore } from '../../unityLayout/sendMessage.store';
import Button from '../../../ui/button';

export const AuthorizationView: React.FC = observer((): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { setAuthPopupActive } = dashboardStore;
  const { resetSection, resetSteps } = authorizationStore;

  const closedPopup = () => {
    searchParams.delete('auth');
    setSearchParams(searchParams, { replace: true });
    setAuthPopupActive(false);
    resetSection();
    resetSteps();
    if (!!authorizationStore.redirectUrl && globalStore.isLogin) {
      globalStore.navigation(authorizationStore.redirectUrl);
      authorizationStore.setRedirectUrl('');
    }
  };

  useEffect(() => {
    sendMessageStore?.lockKeyboardInput();

    return () => {
      sendMessageStore?.unLockKeyboardInput();
    };
  }, []);

  return (
    <div className="popupWrapper">
      <div className="popupLayer" onClick={closedPopup} />
      <div className="popupContainer">
        <div className="popupContainerInner">

          <div className="popupContCelSignIn">
            <AuthMainBlock />
          </div>

          <div className="popupJoin">
            <div className="popupJoinImgWrapper">
              <ImgImporter path="logos/yo-login.png" className="popupJoinImg" />
            </div>

            <div className="popupJoinContent">
              <h3 className="popupJoinTitle">Don't have an account yet?</h3>
              <Button
                  type="rounded-15"
                  size="w100 lg"
                  color="dark"
              >
                <span className="popupJoinContentButtonTxt">Join Now</span>
              </Button>
              <p className="popupJoinText">Unlock premium features by signing up for a free account.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
});
